// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__HEibY","icon":"SortAdornment_icon__1kWwP","up":"SortAdornment_up__2x-sQ","down":"SortAdornment_down__3s1mT","active":"SortAdornment_active__2FO_K"};